import React from "react";

import { StyledInputText, StyledInputTextProps } from "./styled";

type TextInputProps = {
  type?: string;
  min?: number;
  inputValue?: string;
  placeholder?: string;
  disabled?: boolean;
  readOnly?: boolean;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
  onChangeHandler?: React.ChangeEventHandler<HTMLInputElement>;
  onBlurHandler?: React.FocusEventHandler<HTMLInputElement>;
  name?: string;
  autoFocus?: boolean;
  autocomplete?: string;
  maxlength?: string;
} & StyledInputTextProps;

export const TextInput: React.FC<TextInputProps> = ({
  type,
  inputValue,
  onFocus,
  onChangeHandler,
  onBlurHandler,
  placeholder,
  disabled = false,
  readOnly = false,
  name,
  autoFocus,
  autocomplete,
  maxlength,
  ...styles
}) => {
  return (
    <StyledInputText
      type={type}
      value={inputValue}
      onFocus={onFocus}
      onChange={onChangeHandler}
      onBlur={onBlurHandler}
      placeholder={placeholder}
      disabled={disabled}
      readOnly={readOnly}
      name={name}
      autoFocus={autoFocus}
      autoComplete={autocomplete}
      maxLength={maxlength ? Number(maxlength) : -1}
      {...styles}
    />
  );
};
